import { skipToken, useQuery } from "@tanstack/react-query";

import { fetchNotification } from "./fetchNotifications";
import { notificationQueryKeys } from "./query-keys";
import { NOTIFICATION_STALE_TIME_MS } from "../constants";
import type { NotificationData } from "../types";

export function useNotificationDetail(notificationId: NotificationData["id"] | null, placeholder?: NotificationData) {
  return useQuery({
    queryKey: notificationQueryKeys.detail(notificationId),
    queryFn: notificationId ? () => fetchNotification(notificationId) : skipToken,
    placeholderData: placeholder,
    staleTime: NOTIFICATION_STALE_TIME_MS,
    refetchOnMount: true,
  });
}
